import GeocoderStatus = google.maps.GeocoderStatus;

export interface GeoCodeAddressComponent {
	long_name: string;
	short_name: string;
	types: string[];
}

export interface GeoCodeLocation {
	lat: number;
	lng: number;
}

export interface GeoCodeViewport {
	northeast: GeoCodeLocation;
	southwest: GeoCodeLocation;
}

export interface GeoCodeGeometry {
	location: GeoCodeLocation;
	location_type: string;
	viewport: GeoCodeViewport;
}

export interface GeoCodeResult {
	address_components: GeoCodeAddressComponent[];
	formatted_address: string;
	geometry: GeoCodeGeometry;
	place_id: string;
	types: string[];
}

export interface GeoCodeResponse {
	results: GeoCodeResult[];
	status: string;
}

export class GPSService {
	private axios: any;

	constructor() {
	}

	public async GeoCodeLookup(
		address: string,
		key: string
	): Promise<GeoCodeResponse> {
		return new Promise(function(resolve, reject) {
			let googleGeoCoder = new google.maps.Geocoder();
			googleGeoCoder.geocode({ address : address }, function(results, status) {
				if (status.toString() == "OK") {
					let resultItems = [];
					// for each object in the result set
					for (let i = 0; i < results.length; i++) {

						let item = (<any>results[i]);

						// convert the lat long functions into their concrete values for use in different areas of the
						// system - basically converting the google maps object into a GeoCodeGeometry above
						item.geometry.location.lat = item.geometry.location.lat();
						item.geometry.location.lng = item.geometry.location.lng();
						item.geometry.viewport.northeast = {};
						item.geometry.viewport.southwest = {};
						item.geometry.viewport.northeast.lat = item.geometry.viewport.getNorthEast().lat();
						item.geometry.viewport.northeast.lng = item.geometry.viewport.getNorthEast().lng();
						item.geometry.viewport.southwest.lat = item.geometry.viewport.getSouthWest().lat();
						item.geometry.viewport.southwest.lng = item.geometry.viewport.getSouthWest().lng();

						resultItems.push(item);
					}

					resolve({ results: resultItems, status: status.toString() });
				} else {
					reject(new Error("Could not find address"));
				}
			});
		});
	}
}
